import axios from 'axios'

const api = axios.create({
    baseURL: '/api',
})

export const getBuildingByLocation = criteria => api.post(`/building`, criteria)
export const getListrikForTable = criteria => api.post(`/listrikTabel`, criteria)
export const getListrikForGraphLine = criteria => api.post(`/listrikGraphLine`, criteria)
export const getListrikForGraphBar = criteria => api.post(`/listrikGraphBar`, criteria)
export const getAirForTable = criteria => api.post(`/airTabel`, criteria)
export const getAirForGraphLine = criteria => api.post(`/airGraphLine`, criteria)
export const getAirForGraphBar = criteria => api.post(`/airGraphBar`, criteria)

const apis = {
    getBuildingByLocation,
    getListrikForTable,
    getListrikForGraphLine,
    getListrikForGraphBar,
    getAirForTable,
    getAirForGraphLine,
    getAirForGraphBar,
}

export default apis